import { get, post } from '../tools/http';

export default {
    state: {},
    mutations: {},
    actions: {
        async getHiddenFields(){
            const resp = await get('profile', 'user/hiddenFields/get');
            return resp;
        },
        async addHiddenFields(ctx, {fields, id}){
            console.log(fields);
            console.log(id);
            return await post('profile', 'user/hiddenFields/add',
                {
                    hiddenFields: fields,
                    userId: id,
                },
                true);
        },
        async removeHiddenFields(ctx, {fields, id}){
            return await post('profile', 'user/hiddenFields/remove',
                {
                    hiddenFields: fields,
                    userId: id,
                },
                true);
        },
    },
    getters: {},
};